export const getUTCTime = (date: Date) => {
  //get offset of browser's local time (given in minutes by method) compared to UTC in milliseconds
  const localOffset = new Date().getTimezoneOffset() * 60000;
  //get given date and time in UTC
  return new Date(new Date(date).getTime() - localOffset);
};
